import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import routeConstant from '../../../../lib/constants/routeConstant';
import { feedbackButtonStyles as styles } from './feedbackButton.style';
import FeedbackModal from '../../Modals/FeedbackModal/FeedbackModal';
import Button from "../../../shared/Button/Button";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

const FeedbackButton = () => {
    const location = useLocation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1023);

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth < 1024;
            setIsMobile(mobile);
            // If we switch to desktop, reset expanded state if needed
            if (!mobile) setIsExpanded(false);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // List of routes where the feedback button should NOT be shown
    const hideOnRoutes = [
        routeConstant.LOGIN_PAGE,
        routeConstant.SIGNUP_PAGE,
        routeConstant.SPORT_PAGE,
        routeConstant.FORGOT_PASSWORD_PAGE,
        routeConstant.VERIFY_OTP_PAGE,
        routeConstant.CREATE_PASSWORD_PAGE
    ];

    // Check if current path matches any of the hidden routes (using prefix matching for dynamic routes)
    const shouldHide = hideOnRoutes.some(route => location.pathname.startsWith(route));

    if (shouldHide) return null;

    return (
        <>
            {isMobile ? (
                <div 
                    className={styles.mobileContainer}
                    style={{ transform: isExpanded ? 'translateX(0)' : 'translateX(calc(-100% + 32px))' }}
                >
                    {/* Feedback Button (Mobile) */}
                    <button
                        className={styles.drawerButton}
                        onClick={() => setIsModalOpen(true)}
                    >
                        Have Feedback?
                    </button>
                    
                    {/* Drawer Handle / Arrow */}
                    <div 
                        className={styles.arrowHandle}
                        onClick={() => setIsExpanded(!isExpanded)}
                        aria-label={isExpanded ? "Hide Feedback" : "Show Feedback"}
                        title={isExpanded ? "Hide Feedback" : "Show Feedback"}
                    >
                        {isExpanded ? <ChevronLeftIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
                    </div>
                </div>
            ) : (
                <Button
                    variant="primaryOutline"
                    className={styles.button}
                    onClick={() => setIsModalOpen(true)}
                    aria-label="Have Feedback?"
                >
                    Have Feedback?
                </Button>
            )}

            <FeedbackModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            />
        </>
    );
};

export default FeedbackButton;
